<template>
  <div id="app">
    <Banner/>
    <Skills/>

  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'
import Banner from './components/Banner.vue'
import Skills from './components/Skills.vue'

export default {
  name: 'App',
  components: {
    HelloWorld,
    Banner,
    Skills
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>
